<template>
  <div class="digido-form-builder digido-form-viewer">
    <form-builder :form="value" v-bind:options="{}" v-on:change="(schema) => update(schema)"></form-builder>
  </div>
</template>

<script>
import { FormBuilder } from 'vue-formio';
export default {
  name: 'DefaultForm',
  components: {FormBuilder},
  methods: {
    update(val) {
      if(val.components) {
        this.$emit('input', val)
      }
    }
  },
  // methods: {
  //   initForm () {
  //     if(this.formApi) {
  //       this.formApi.instance.destroy()
  //     }
  //
  //     this.formApi = new FormBuilder(document.getElementById(this.id), this.value)
  //     this.formApi.icons = 'glyphicon'
  //
  //     this.formApi.render().then((builder) => {
  //       builder.on('change', () => {
  //         this.$emit('input', builder.form)
  //       })
  //     })
  //
  //   }
  // },
  // mounted () {
  //   this.$nextTick(() => {
  //     this.initForm()
  //   })
  // },
  // destroyed () {
  //   this.formApi.instance.destroy()
  // },
  // data () {
  //   return {
  //     id: 'formio-' + uuidv1(),
  //     formApi: null,
  //   }
  // },
  props: ['value']
}
</script>

<style lang="scss">
  .formio-component-className,
  .formio-component-customClass,
  .formio-component-refreshOnChange,
  .formio-component-multiple,
  .formio-component-persistent {
    display: none;
  }

  .component-preview {
    padding: 5px;
  }

  .formio-component-tabs {
    /*ul {*/
    /*li:nth-of-type(6) {*/
    /*display: none;*/
    /*}*/

    /*li:nth-of-type(5) {*/
    /*display: none;*/
    /*}*/

    /*li:nth-of-type(4) {*/
    /*display: none;*/
    /*}*/

    /*li:nth-of-type(2) {*/
    /*display: none;*/
    /*}*/
    /*}*/

    #logic, #conditional, #data {
      display: none;
    }

    #validation {
      .card {
        display: none;
      }
    }
  }


</style>